import { checkinApi } from '@/services/api/httpClient';
import moment from 'moment';
import {
  SET_TEAM_NAME,
  SET_FLOW_STEPS,
  SET_VACCINE_FLOW,
  SET_COLLABORATOR_FLOW,
  SET_IS_SCHEDULED_ADMISSION,
  SET_HAS_SURVEY,
  SET_USER_CHECKIN_ORIGIN,
} from './mutation-types';

const actions = {
  setUserCheckinOrigin({ commit }, origin) {
    commit(SET_USER_CHECKIN_ORIGIN, origin);
  },

  setTeamName({ commit }, teamName) {
    commit(SET_TEAM_NAME, teamName);
  },

  updateFlowSteps({ getters, commit }, flowStep) {
    const { flowSteps } = getters.getGlobalState;
    const [step] = flowStep;
    const flowStepIndex = flowSteps.findIndex((flowStep) => flowStep[0] === step);

    if (flowStepIndex === -1) {
      flowSteps.push(flowStep);
    } else {
      flowSteps[flowStepIndex] = flowStep;
    }

    commit(SET_FLOW_STEPS, flowSteps);
  },

  setVaccineFlow({ commit }, data) {
    commit(SET_VACCINE_FLOW, data);
  },

  setCollaboratorFlow({ commit }, data) {
    commit(SET_COLLABORATOR_FLOW, data);
  },

  setIsScheduledAdmission({ commit }, data) {
    commit(SET_IS_SCHEDULED_ADMISSION, data);
  },

  setHasSurvey({ commit }, data) {
    commit(SET_HAS_SURVEY, data);
  },

  skipServiceDeskFlowFail({ commit }, data) {
    commit('SET_SKIP_SERVICE_DESK_FLOW_FAIL', data);
  },

  async checkPaymentAuthorization({ commit }, admissionId) {
    commit('SET_ADMISSION_AUTHORIZATION', false);

    if (!admissionId) return;

    try {
      const request = await checkinApi().get(
        `/admission/${admissionId}/flow?fields=skipServiceDeskHealthInsuranceFlow`,
      );
      const response = request.data;
      if (response) {
        commit('SET_ADMISSION_AUTHORIZATION', response.skipServiceDeskHealthInsuranceFlow);
      }
    } catch (error) {
      console.error('checkPaymentAuthorization ERROR', error);
    }
  },

  setHourAdmissionWithoutScheduling({ commit }) {
    commit('SET_HOUR_ADMISSION_WITHOUT_SCHEDULING', moment(new Date()).format('HH:mm'));
  },

  async getEndMessagesByFlow({ commit }) {
    const defaultEndMessages = {
      collaboratorVaccineFlow: 'Informe ao anfitrião que você já fez check-in e confirmou chegada.',
      goToServiceDeskFlow: 'Retire uma senha para ser atendido no guichê.',
      goToServiceDeskQrCodeFlow: 'Aguarde sua senha ser chamada para finalizar seu atendimento.',
      isInCompanyFlow: 'Realize sua vacinação na data marcada.',
      skipServiceDeskFlowFail: 'Falta pouco, vamos concluir seu atendimento na recepção.',
      skipServiceDeskFlowSucess:
        'Informe ao anfitrião que você já fez check-in e confirmou chegada.',
    };

    try {
      const response = await checkinApi().get('global-settings/flow/end-message');
      if (response.data) {
        commit('SET_END_FLOW_MESSAGE_BY_FLOW', response.data);
        return;
      }
      commit('SET_END_FLOW_MESSAGE_BY_FLOW', defaultEndMessages);
    } catch {
      commit('SET_END_FLOW_MESSAGE_BY_FLOW', defaultEndMessages);
    }
  },

  setServicesChanged({ commit }, data) {
    commit('SET_SERVICES_CHANGE', data);
  },

  setButtonConfirmArrival({ commit }, data) {
    commit('SET_BUTTON_CONFIRM_ARRIVAL', data);
  },

  setBradescoFlow({ commit }, data) {
    commit('SET_BRADESCO_FLOW', data);
  },
};

export default actions;
